/* TypeScript file generated from Spaces__Row__Renderer__BlockIndex.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as Spaces__Row__Renderer__BlockIndexJS from './Spaces__Row__Renderer__BlockIndex.bs.js';

export const registerBlocks: () => void = Spaces__Row__Renderer__BlockIndexJS.registerBlocks as any;
